import { useCategoryRevamp } from '@modules/category/hook/use-category-revamp';

/**
 * Sort by on the current (pre-revamp) site: directory bars, rooms, and
 * professional tabs / Refine.
 *
 * Follows `revamp_2026` (and the `?categoryRevamp=1` override).
 * Revamp browse uses Display in this slot; the URL and loader still honour an
 * existing `sort_*` segment.
 *
 * A typed search term ranks by relevance rather than the entity default. The
 * current-site dropdown can still label the grid Featured/Trending in that
 * case; add a relevance option before showing sort on the revamp bars.
 */
export function useSortControlsEnabled(): boolean {
    return !useCategoryRevamp();
}
